import { useEffect, useRef } from "react";
import { Track, Wrapper } from "./Fader.style";

interface Props {
	value: number;
	min: number;
	max: number;
	step: number;
	onValueChange: (val: number) => void;
}

const Fader: React.FC<Props> = ({ value, min, max, step, onValueChange }) => {
	const tarckRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (tarckRef.current) {
			const h = value * 100;
			tarckRef.current.style.height = `${h}px`;
		}
	}, [value]);
	return (
		<Wrapper>
			<input
				type="range"
				value={value}
				min={min}
				max={max}
				step={step}
				onChange={(e) => {
					const val = Number(e.target.value);
					onValueChange(val);
				}}
			/>
			<Track ref={tarckRef} />
		</Wrapper>
	);
};

export default Fader;
